/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PlansTable } from "./components/PlansTable";
import { PlansTableHeader } from "./components/PlansTableHeader";

type Props = {
  resourceGroupId: string;
};

export function PlansTab({ resourceGroupId }: Props) {
  return (
    <>
      <PlansTableHeader />
      <PlansTable resourceGroupId={resourceGroupId} />
    </>
  );
}
